export default __webpack_public_path__ + "static/media/twitter.6cd0c2b3.png";